/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --background: var(--nve-sys-layer-container-background);
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  --color: var(--nve-sys-layer-canvas-color);
  --box-shadow: var(--nve-ref-shadow-300);
  --panel-button-border-radius: 0 var(--nve-ref-border-radius-full) var(--nve-ref-border-radius-full) 0;
  overflow: hidden;
  -webkit-transition: width 240ms ease;
  -webkit-transition: height 240ms ease;
  contain: none;
  position: relative;
}

[internal-host] {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  height: 100%;
  color: var(--color);
  box-shadow: var(--box-shadow);
  background: var(--background);
}

:host(:not(:state(expanded))) {
  --box-shadow: none;
}

:host(:not([closable], :state(expanded))) [internal-host] {
  width: var(--nve-ref-size-800) !important;
  height: var(--nve-ref-size-800) !important;
  background: none;
}

:host(:not([closable], :state(expanded))) {
  pointer-events: none;
}

:host(:not([closable], :state(expanded))) slot {
  display: none;
}

:host(:not([closable], :state(expanded))) nve-icon-button {
  position: initial;
  pointer-events: auto;
  border-radius: var(--panel-button-border-radius);
  background: var(--background);
  align-items: center;
  justify-content: center;
}

:host([closable]:not(:state(expanded))) {
  display: none;
}

:host([side='right']) {
  float: right;
}

:host(:not([closable], :state(expanded))[side='right']) nve-icon-button {
  --panel-button-border-radius: var(--nve-ref-border-radius-full) 0 0 var(--nve-ref-border-radius-full);
}

.header {
  min-height: var(--nve-ref-size-900);
  display: flex;
  align-items: start;
}

:host(:state(expanded)) .header {
  border-block-end: var(--border-bottom);
}

.content {
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-grow: 1;
}

nve-icon-button {
  margin-block-start: var(--nve-ref-space-xxs);
  margin-inline: auto var(--nve-ref-space-xxs);
  z-index: 99;
}
